import crazyJackImage from '../img/nfts/1.jpg'
import crazyJackQR from '../img/qrCodes/1.jpg'
import bearMoonImage from '../img/nfts/2.jpg'
import bearMoonQR from '../img/qrCodes/2.jpg'
import warmJerryImage from '../img/nfts/3.jpg'
import warmJerryQR from '../img/qrCodes/3.jpg'
import bearcuryImage from '../img/nfts/4.jpg'
import bearcuryQR from '../img/qrCodes/4.jpg'
import snifferImage from '../img/nfts/5.jpg'
import snifferQR from '../img/qrCodes/5.jpg'
import jupiBearImage from '../img/nfts/6.jpg'
import jupiBearQR from '../img/qrCodes/6.jpg'
import mrGreenImage from '../img/nfts/7.jpg'
import mrGreenQR from '../img/qrCodes/7.jpg'
import sailorBearsImage from '../img/nfts/8.jpg'
import sailorBearsQR from '../img/qrCodes/8.jpg'
import daizyBearImage from '../img/nfts/9.jpg'
import daizyBearQR from '../img/qrCodes/9.jpg'
import bearVenusImage from '../img/nfts/10.jpg'
import bearVenusQR from '../img/qrCodes/10.jpg'
import frozyBearImage from '../img/nfts/11.jpg'
import frozyBearQR from '../img/qrCodes/11.jpg'
import sirBearLemonImage from '../img/nfts/12.jpg'
import sirBearLemonQR from '../img/qrCodes/12.jpg'

export const NFTs = [
    {
        id: 1,
        name: 'Crazy Jack',
        image: crazyJackImage,
        qrCode: crazyJackQR,
    },
    {
        id: 2,
        name: 'Sailor Bearmoon',
        image: bearMoonImage,
        qrCode: bearMoonQR,
    },
    {
        id: 3,
        name: 'Warm Jerry',
        image: warmJerryImage,
        qrCode: warmJerryQR,
    },
    {
        id: 4,
        name: 'Sailor Bearcury',
        image: bearcuryImage,
        qrCode: bearcuryQR,
    },
    {
        id: 5,
        name: 'Sniffer',
        image: snifferImage,
        qrCode: snifferQR,
    },
    {
        id: 6,
        name: 'Sailor Jupibear',
        image: jupiBearImage,
        qrCode: jupiBearQR,
    },
    {
        id: 7,
        name: 'Mr Green',
        image: mrGreenImage,
        qrCode: mrGreenQR,
    },
    {
        id: 8,
        name: 'Sailor Bears',
        image: sailorBearsImage,
        qrCode: sailorBearsQR,
    },
    {
        id: 9,
        name: 'Daizy Bear',
        image: daizyBearImage,
        qrCode: daizyBearQR,
    },
    {
        id: 10,
        name: 'Sailor Bearvenus',
        image: bearVenusImage,
        qrCode: bearVenusQR,
    },
    {
        id: 11,
        name: 'Frozy Bear',
        image: frozyBearImage,
        qrCode: frozyBearQR,
    },
    {
        id: 12,
        name: 'Sir Bear Lemon',
        image: sirBearLemonImage,
        qrCode: sirBearLemonQR,
    },
]